import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions/index';
import { Row, Col } from 'react-materialize';

class RequestPermission extends Component {
	constructor(props) {
		super(props);

		this.requestPermissions = this.requestPermissions.bind(this);
	}

	requestPermissions() {
		this.props.setWaitingForPermission(true);

		navigator.mediaDevices
			.getUserMedia({ audio: true })
			.then(() => {
				this.props.setNavigatorAudioPermission('granted');
			})
			.catch((error) => {
				console.error(error);
				this.props.setNavigatorAudioPermission('denied');
			})
			.finally(() => {
				this.props.setWaitingForPermission(false);
			});
	}

	render() {
		return (
			<Row className="valign-wrapper dp-container mb-0">
				<Col s={12}>
					<div>
						<div className="dp-instructions">Audio Access Required</div>
						<Row>
							<Col s={12}>
								<div className="dp-instructions-subtitle">
									<p>
										It's necessary to access your audio in order to test your
										speakers before the Survey begins
									</p>
									<p>Because of this, we need to ask for some of your browser's permissions</p>
								</div>
							</Col>
						</Row>
						<Row>
							<button
								style={{ minWidth: '200px' }}
								onClick={this.requestPermissions}
								disabled={this.props.waitingForPermission}
							>
								GRANT PERMISSIONS
							</button>
						</Row>
					</div>
				</Col>
			</Row>
		);
	}
}

const mapStateToProps = (state) => ({
	waitingForPermission: state.navigatorPermissions.waitingForPermission,
});

export default connect(mapStateToProps, actions)(RequestPermission);



// WEBPACK FOOTER //
// ./src/components/tech-check/RequestPermission.js